import React from "react";
import { HomesHeader } from "./HomesHeader";
import { HomesFooter } from "./HomesFooter";
import { SavedProvider } from "@/context/SavedContext";

export function HomesLayout({ children }) {
  return (
    <SavedProvider>
      <div className="min-h-screen bg-white">
        <HomesHeader />
        <main>{children}</main>
        <HomesFooter />
      </div>
    </SavedProvider>
  );
}
